/**
 * // Utilisation de iframePopin
 *
 * var maDialog = $.iframePopin({
 * 	title: "Titre de la fenêtre modale",
 *  url: "/url/de/l-iframe/a/afficher,
 *  buttons: {
 *   unBouton: {
 *    title: "Titre du premier bouton",
 *    callback: function(iframe) {
 *     // ...
 *     // iframe correspond au contenu DOM/jQuery de l'iframe
 *     // this.close() : ferme la popup
 *    }
 *   },
 *   unAutreBouton: {
 *    title: "Titre de l'autre bouton",
 *    callback: function(iframe) {
 *     // ...
 *    }
 *   },
 *   // ...
 *  },
 *  onClose: function(iframe) {
 *   // action effectuée après la fermeture de la popin avec la croix.
 *   // l'appel de this.close() n'est pas nécessaire
 *  }
 * });
 *
 * // Pour ouvrir la popup créée, utiliser maDialog.open();
 * // Autres paramètres utilisables à la création de la popup :
 * // - autoOpen: ouvre la popup automatiquement si true (l'appel de maDialog.open() n'est pas nécessaire) [false par défaut]
 * // - modal: rend la popin modale [true par défaut]
 * // - width, height: dimensions d'origine de la boîte de dialogue
 */
(function ($) {

    /**
     * Test si le code s'execute à l'intérieur d'une iFrame ou directement dans la page principale.
     * @returns {boolean} true si dans une iFrame
     */
    function isInIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    /**
     * Ajoute une classe au body pour marquer la présence d'une iFrame (et prévient la fenêtre parente si l'iframe est ouverte dans une iframe)
     */
    function addClassesIframe() {
        document.querySelector('body').classList.add('has_iframe_open');
        if (isInIframe()) {
            parent.postMessage({
                action: 'addClass',
                class: 'has_sub_iframe'
            });
        }
    }

    /**
     * Supprime la classe du body marquant la présence d'une iFrame (et prévient la fenêtre parente si l'iframe est fermée dans une iframe)
     */
    function removeClassesIframe() {
        document.querySelector('body').classList.remove('has_iframe_open');
        if (isInIframe()) {
            parent.postMessage({
                action: 'removeClass',
                class: 'has_sub_iframe'
            });
        }
    }

    /**
     * Prise en compte du message d'ajout/suppression de la classe.
     */
    window.addEventListener('message', ({data}) => {
        if (data.action === 'addClass') {
            document.querySelector('body').classList.add(data.class);
        }
        if (data.action === 'removeClass') {
            document.querySelector('body').classList.remove(data.class);
        }
    });

    $.iframePopin = function (params) {
        this.defaultParams = {
            autoOpen: false,
            modal: true,
            resizable: true,
            width: 520,
            height: 250
        };
        this.container = $("<div>").attr("id", "iframePopin").css({'overflow': 'hidden'});
        this.iFrame = $('<iframe>').appendTo(this.container);
        $("<div>").addClass("actions").appendTo(this.container);
        this.action = $("<input>").attr("type", "button");
        const wrapper = this;
        const instance = {
            options: $.extend(wrapper.defaultParams, params || {}),
            dialog: null,
            iFrame: null,
            open: function () {
                this.dialog.dialog('open');
                return this;
            },
            close: function() {
                removeClassesIframe();
                this.dialog.dialog("destroy");
            },
            destroy: function () {
                removeClassesIframe();
                this.dialog.dialog("destroy");
            },
            init: function () {
                addClassesIframe();
                const actionButton = wrapper.action.clone();
                const containerTemplate = wrapper.container.clone();
                const $actions = containerTemplate.find(".actions");
                const self = this;
                containerTemplate.attr("title", this.options.title);
                containerTemplate.find("iframe").attr("src", this.options.url).css(
                    {
                        width: '100%',
                        height: 150,
                        'overflow-x': 'hidden'
                    });
                $actions.html("");
                const iframe = containerTemplate.find("iframe")[0];
                if (iframe) {
                    iframe.addEventListener('load', _iFrameLoaded);
                }
                if (!$.isEmptyObject(this.options.buttons)) {
                    $.each(
                        this.options.buttons, function (k, v) {
                            const button = actionButton.clone();
                            button
                                .attr("name", k)
                                .attr("value", v.title)
                                .attr("class", v.class)
                                .click(
                                function (e) {
                                    v.callback.call(self, containerTemplate.find("iframe").contents(), e, containerTemplate.find("iframe"));
                                });
                            $actions.append(button);
                            $('<span>').html('&nbsp;').appendTo($actions); // Permet d'espacer les boutons de la popin
                        });
                } else {
                    $actions.remove();
                }
                this.iFrame = containerTemplate.find('iframe');
                this.dialog = containerTemplate.dialog(
                    {
                        autoOpen: this.options.autoOpen,
                        modal: this.options.modal,
                        resizable: this.options.resizable,
                        minWidth: this.options.width,
                        minHeight: this.options.height,
                        width: this.options.width,
                        height: this.options.height,
                        closeOnEscape: false
                    });
                this.dialog.closest('div.ui-dialog').find(".ui-dialog-titlebar-close").click(
                    function (event, ui) {
                        if (!!self.options.onClose) {
                            self.options.onClose.call(self, containerTemplate.find("iframe").contents(), event, ui);
                        }
                    });
            }
        };

        function _iFrameLoaded() {
            const $this = $(this);
            if ($this.contents().find('body').is('.login')) {
                window.location = window.location.origin + "/adminsite";
            } else {
                $this.contents().find('body').css({'background': '#fff'});
                setTimeout(_optimizeSize, 100);
            }
        }

        function _optimizeSize() {
            const $popin = $('#iframePopin');
            const $iFrame = $popin.find("iframe");
            const $dialog = $popin.closest('.ui-dialog');
            const titleBarHeight = $popin.closest('.ui-dialog').find('.ui-dialog-titlebar').outerHeight(true);
            const actionBarHeight = $popin.find('.actions').outerHeight(true);
            const popinPaddingHeight = $.parseInteger($popin.css('padding-top')) + $.parseInteger($popin.css('padding-bottom'));
            const dialogPaddingHeight = $.parseInteger($dialog.css('padding-top')) + $.parseInteger($dialog.css('padding-bottom'));
            const clientHeight = $(window).height();
            const maxiFrameHeight = clientHeight - (titleBarHeight + actionBarHeight);
            let contentHeight = $iFrame.contents().find('html').outerHeight(true);
            contentHeight = contentHeight < maxiFrameHeight ? contentHeight : maxiFrameHeight;
            let dialogFinalHeight = contentHeight + popinPaddingHeight + titleBarHeight + dialogPaddingHeight;
            dialogFinalHeight = dialogFinalHeight > maxiFrameHeight ? maxiFrameHeight : dialogFinalHeight;
            const optimizeTop = ((clientHeight / 2) - (dialogFinalHeight / 2)) + $(window).scrollTop();
            $dialog.transition({top: optimizeTop});
            $popin.transition({height: contentHeight + actionBarHeight + popinPaddingHeight});
            $iFrame.transition({height: contentHeight});
        }

        instance.init();
        return instance;
    };
})(jQuery);
